export interface DefaultPackage {
    id: number;
    feature_name: string;
    tab: string;
    key_name: string;
    now_available: number;
    category?: 'Others' | 'Building Control' | null;
    icChecked: boolean,
}

export const mapDefaultPackage = (data: any): DefaultPackage => {
    if (!data) {
        throw new Error('Invalied DefaultPackage type')
    }

    const defaultPackage: DefaultPackage = {
        id: data.id,
        feature_name: data.feature_name,
        tab: data.tab,
        key_name: data.key_name,
        now_available: data.now_available,
        category: data.category,
        icChecked: false,
    }

    return defaultPackage;
}

export const mapDefaultPackages = (data: any[]): DefaultPackage[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid DefaultPackage data');
    }

    return data.map(mapDefaultPackage);
};
